<template>
  <div class="micropoint">
    <div class="searchWrap">
      <!-- <div class="storeLeft">
        <p @click="handleShowSelectVpn">
          {{ vpnInfo.name }}
          <van-icon
            v-if="!saasCode && !isSureVpn"
            name="arrow-down"
            color="#969799"
          />
        </p>
      </div> -->
      <div class="storeLeft">
        <p @click="handleShowSelectDiningRoom">
          {{ diningRoomInfo.name }}
          <van-icon name="arrow-down" color="#969799" />
        </p>
      </div>
      <van-search
        v-model="searchKey"
        shape="round"
        show-action
        maxlength="30"
        placeholder="想吃什么搜一搜"
        @search="onSubmit"
        @clear="onSubmit"
        class="point_search"
      >
        <template #action>
          <div
            :style="{ color: searchKey.length > 0 ? 'var(--tc)' : '#c8c8c8' }"
            @click="onSubmit"
          >
            搜索
          </div>
        </template>
      </van-search>
    </div>
    <div class="notice_con" v-if="noticeList.length > 0">
      <div class="notice_icon_con">
        <img class="full_img" src="@/assets/images/point-notice.png" alt="" />
      </div>
      <div class="scroll-container" :style="{ height: `40px` }">
        <ul
          class="scroll-ul"
          :style="{
            transform: `translate3d(0, ${yScroll}px, 0)`,
            transition: `ease all 1s`,
          }"
        >
          <li
            v-for="(item, index) in noticeList"
            :key="index"
            class="c-item"
            :style="{
              height: '40px',
              'line-height': '40px',
            }"
          >
            <!-- <img
              v-if="item.content"
              class="a-item"
              :src="item.avatar"
            > -->
            <div v-if="item.content" class="c-content">
              {{ item.content }}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="pageTop" v-if="swipeList.length > 0">
      <van-swipe :autoplay="10000" indicator-color="white">
        <van-swipe-item v-for="(image, index) in swipeList" :key="index">
          <img class="newImg" v-lazy="image" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="recommendGoodsListWrap" v-if="recommendGoodsList.length > 0">
      <h3>推荐菜品</h3>
      <ul class="recommend_goods_con">
        <li v-for="(rItem, index) in recommendGoodsList" :key="index">
          <div class="goods-image">
            <img
              class="full_img"
              v-lazy="rItem.PicUrl ? rItem.PicUrl : $root.defaultImg"
              alt=""
            />
          </div>
          <div class="goods_info_con">
            <p class="goods_name">{{ rItem.GoodsName }}</p>
            <div class="money-box">
              <div class="main-money c-tc">
                <span class="c-yang">¥</span>
                <span class="">{{ rItem.Price }}</span>
                <i v-if="rItem.IsMultiSpecific">起</i>
              </div>
              <div
                class="number_sall_out"
                v-if="rItem.IsSellOut && rItem.SellOutNumber === 0"
              >
                售罄
              </div>
              <div class="changeNumBar" v-else>
                <div>
                  <!-- 有备注：显示选规格，每次点击弹备注框，确定后购物车+1 -->
                  <van-button
                    v-if="hasGoodsRemark(rItem)"
                    class="select-spec-btn"
                    color="#CCA567"
                    size="mini"
                    round
                    @click.stop="openRemarkModal(rItem)"
                    >选规格</van-button
                  >
                  <van-button
                    v-else-if="
                      rItem.MinBuyCount &&
                      rItem.MinBuyCount != 1 &&
                      rItem.num == 0
                    "
                    color="#CCA567"
                    size="mini"
                    @click="handleSetGoodsAndPrice(rItem, 'add')"
                    >{{ rItem.MinBuyCount }}份起购</van-button
                  >
                  <van-stepper
                    v-else
                    :value="rItem.num"
                    theme="round"
                    min="0"
                    disable-input
                    async-change
                    button-size="22"
                    :show-minus="rItem.num > 0"
                    :show-input="rItem.num > 0"
                    :disable-plus="
                      rItem.IsSellOut &&
                      rItem.SellOutNumber != null &&
                      rItem.num + 1 > rItem.SellOutNumber
                    "
                    @plus="handleSetGoodsAndPrice(rItem, 'add')"
                    @minus="handleSetGoodsAndPrice(rItem, 'minus')"
                  />
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="micropointContainer">
      <div class="micropointSideNavbar" ref="menu">
        <div class="sideNavbar">
          <p
            v-for="(item, index) in catalogList"
            :key="index"
            :class="index === catalog ? 'active' : ''"
            @click="catalogStyle(index)"
          >
            <a>{{ item.name }}</a>
            <van-badge
              color="#AC8D5F"
              v-if="item.num > 0"
              :content="item.num"
              max="99"
            />
          </p>
        </div>
      </div>
      <div
        class="micropointGoodsList"
        ref="menuList"
        v-show="goodsList.length > 0"
        @scroll.passive="scroll"
      >
        <div class="goodsList">
          <ul
            :class="
              index === goodsList.length - 1 ? 'lastList bigList' : 'bigList'
            "
            v-for="(item, index) in goodsList"
            :key="index"
            :style="{
              'margin-bottom':
                index === goodsList.length - 1 ? hackMarginBottom + 'px' : 0,
            }"
          >
            <div class="goods_title_box">
              <div class="goods_title_con">
                <p>{{ catalogList[index].name }}</p>
                <!-- <p>{{ catalogList[index].helpName ? catalogList[index].helpName : 'Delicious food' }}</p> -->
              </div>
            </div>

            <li
              v-for="(itemd,kkkk) in goodsList[index]"
              :key="itemd.Id"
              @click="selfHelpPointDetails(itemd)"
              :class="itemd.IsRecommend ? 'recommend_goods_item' : ''"
            >
              <!-- v-if="!(itemd.EnableSale === false && (itemd.DisableSaleRemark === '' || itemd.DisableSaleRemark === null))">  -->
              <div class="goodsImg" @click.stop="previewGoodsImg(itemd)">
                <img
                  class="full_img"
                  v-lazy="itemd.PicUrl ? itemd.PicUrl : $root.defaultImg"
                  alt=""
                />
                <p v-if="itemd.IsRecommend" class="recommend_con">推荐</p>
              </div>
              <div class="goodsDetails">
                <div class="goodsName">
                  {{ itemd.GoodsName }}
    
                </div>
                <div class="saleNum" style="margin-bottom: 5px">
                  {{ itemd.Description }}
                </div>
                <div class="saleNum" style="display: flex;">已售{{ itemd.ConsumeCount }}</div>
                <ul v-if="itemd.LabelText&& itemd.LabelText.length > 0" class="label_list_con">
                  <li
                    v-for="(labelItem, labelIndex) in itemd.LabelText"
                    :key="labelIndex"
                  >
                    {{ labelItem }}
                  </li>
                </ul>
                <!-- 餐段显示 -->
                <!-- <div class="sale_time_area" v-if="itemd.CurrentMealSection&&itemd.BuyLimit">
                  {{ `${itemd.CurrentMealSection.StartTime}-${itemd.CurrentMealSection.EndTime}餐段内限点${itemd.BuyLimit}份`}}
                </div> -->
                <!-- <div class="sellOut" v-if="itemd.EstimateClear === 'true' || itemd.ToDaySalesNum >= itemd.ToDayStock">
                    已售罄
                  </div>
                  <div class="disableSaleRemark" v-else-if="!itemd.EnableSale && itemd.DisableSaleRemark">
                    {{ itemd.DisableSaleRemark }}
                  </div> -->

                <!-- <div class="disableSaleRemark" v-if="itemd.NotInMealTime">
                   {{ itemd.MealTimeRange ? `${itemd.MealTimeRange}供餐` : '非餐段' }}
                </div> -->
                <div class="lastLine">
                  <div class="c-f">
                    <div class="price c-orange">
                      <a>￥{{ itemd.Price }}</a>
                      <i v-if="itemd.IsMultiSpecific">起</i>
                      <i v-if="itemd.Unit"> /{{ itemd.Unit }}</i>
                      
                      <!-- <div class="vipPrice" v-if="itemd.MemberPrice">
                    <a>{{ itemd.MemberPrice }}</a>
                  </div>
                  <b v-if="!itemd.ShowPrice && itemd.Price > itemd.PresentPrice">￥{{ itemd.Price }}</b> -->
                    </div>
                      
                    <span v-if="itemd.ShowPrice" class="cross-price"
                      >￥{{ itemd.ShowPrice }}</span
                    >
                  </div>

                  <!-- <div class="changeNumBar"  v-if="itemd.EstimateClear !== 'true'&&!itemd.NotInMealTime"> -->
                  <!-- :step="itemd.num>0?itemd.StepNum:itemd.MinBuyCount" -->
                  <div
                    class="number_sall_out"
                    v-if="itemd.IsSellOut && itemd.SellOutNumber === 0"
                  >
                    售罄
                  </div>
                  <div class="changeNumBar" v-else>
                    <div>
                      <!-- 有备注：显示选规格，每次点击弹备注框，确定后购物车+1 -->
                      <van-button
                        v-if="hasGoodsRemark(itemd)"
                        class="select-spec-btn"
                        color="#CCA567"
                        size="mini"
                        round
                        @click.stop="openRemarkModal(itemd)"
                        >选规格</van-button
                      >
                      <van-button
                        v-else-if="
                          itemd.MinBuyCount &&
                          itemd.MinBuyCount != 1 &&
                          itemd.num == 0
                        "
                        color="#CCA567"
                        size="mini"
                        @click="handleSetGoodsAndPrice(itemd, 'add')"
                        >{{ itemd.MinBuyCount }}份起购</van-button
                      >
                      <van-stepper
                        v-else
                        :value="itemd.num"
                        theme="round"
                        min="0"
                        disable-input
                        async-change
                        button-size="22"
                        :show-minus="itemd.num > 0"
                        :show-input="itemd.num > 0"
                        :disable-plus="
                          itemd.IsSellOut &&
                          itemd.SellOutNumber != null &&
                          itemd.num + 1 > itemd.SellOutNumber
                        "
                        @plus="handleSetGoodsAndPrice(itemd, 'add')"
                        @minus="handleSetGoodsAndPrice(itemd, 'minus')"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 购物车弹窗 -->
    <van-popup class="shop_cart_con" round v-model="maskType" position="bottom">
      <div class="cartTitle">
        <span> 已选餐品 </span>
        <div class="clear" @click="clearShoppingCar">
          <van-icon name="delete-o" size="17" />
          <span>清空购物车</span>
        </div>
      </div>
      <div class="cart_goods_con">
        <goodListCard :carGoodsList="carGoodsList" :isChangeNum="true">
          <template v-slot:default="slotDataObj">
            <van-stepper
              :value="slotDataObj.goodsItem.num"
              theme="round"
              button-size="22"
              min="0"
              disable-input
              async-change
              :show-minus="slotDataObj.goodsItem.num > 0"
              :show-input="slotDataObj.goodsItem.num > 0"
              :disable-plus="
                slotDataObj.goodsItem.IsSellOut &&
                slotDataObj.goodsItem.SellOutNumber != null &&
                slotDataObj.goodsItem.num + 1 >
                  slotDataObj.goodsItem.SellOutNumber
              "
              @plus="
                handleSetGoodsAndPrice(slotDataObj.goodsItem, 'add', 'cart')
              "
              @minus="
                handleSetGoodsAndPrice(slotDataObj.goodsItem, 'minus', 'cart')
              "
            />
          </template>
          <template v-slot:mealName="slotDataObj">
            <div
              class="meal_desc_con"
              @click="handleShowSelectSetmeal(slotDataObj.goodsItem, 'edit')"
            >
              <p>{{ slotDataObj.goodsItem.mealNameStr }}</p>
              <img src="@/assets/images/down_icon.png" alt="" />
            </div>
          </template>
        </goodListCard>
      </div>
      <div class="cart_footer">
        <div class="count_con">
          共{{ allNum }}份餐品，合计 <span>￥{{ allPrice }}</span>
        </div>
        <van-button
          color="#333"
          round
          :disabled="allNum <= 0"
          @click="settlement"
          >去下单</van-button
        >
      </div>
    </van-popup>
    <!-- 选择规格弹窗 -->
    <van-overlay :show="showSelectModal" z-index="5">
      <div class="overlay_con">
        <div class="select_specifications_con">
          <p class="goo_name van-ellipsis">{{ foodInfo.GoodsName }}</p>
          <template
            v-if="foodInfo.Specifications && foodInfo.Specifications.length > 0"
          >
            <div class="c-lightgrey">规格</div>
            <ul>
              <li
                v-for="item in foodInfo.Specifications"
                :key="item.Id"
                :class="item.Id == specificationInfo.SpecificId ? 'active' : ''"
                @click="handleSelectSpecific(item)"
              >
                {{ item.Name }}
              </li>
            </ul>
          </template>

          <template
            v-if="foodInfo.MethodArray && foodInfo.MethodArray.length > 0"
          >
            <div class="c-lightgrey">做法</div>
            <ul>
              <li
                v-for="(item, index) in foodInfo.MethodArray"
                :key="index"
                :class="item == specificationInfo.MethodName ? 'active' : ''"
                @click="handleSelectMethod(item)"
              >
                {{ item }}
              </li>
            </ul>
          </template>

          <template
            v-if="foodInfo.TasteArray && foodInfo.TasteArray.length > 0"
          >
            <div class="c-lightgrey">口味</div>
            <ul>
              <li
                v-for="(item, index) in foodInfo.TasteArray"
                :key="index"
                :class="!!specificationInfo.TasteNameObj[item] ? 'active' : ''"
                @click="handleSelectTaste(item)"
              >
                {{ item }}
              </li>
            </ul>
          </template>

          <div class="specifications_input van-hairline--top">
            <p>
              单价<span class="c-orange">￥{{ specificationInfo.Price }}</span>
            </p>
            <p>
              <van-stepper
                :value="specificationInfo.num"
                theme="round"
                min="0"
                disable-input
                async-change
                button-size="22"
                :show-minus="specificationInfo.num > 0"
                :show-input="specificationInfo.num > 0"
                @plus="
                  handleSetGoodsAndPrice(specificationInfo, 'add', 'modal')
                "
                @minus="
                  handleSetGoodsAndPrice(specificationInfo, 'minus', 'modal')
                "
              />
            </p>
          </div>
          <van-icon
            name="close"
            class="close_btn_con"
            color="#fff"
            size="30"
            @click="showSelectModal = false"
          />
        </div>
      </div>
    </van-overlay>
    <!-- 商品备注弹窗 -->
    <van-overlay :show="showRemarkModal" z-index="6" @click="closeRemarkModal">
      <div class="remark_overlay_con" @click.stop>
        <div class="goods_remark_modal">
          <p class="remark_modal_title">请填写您的备注</p>
          <div
            class="remark_tag_list"
            v-if="remarkDefaultOptions.length > 0"
          >
            <button
              v-for="(tag, tagIndex) in remarkDefaultOptions"
              :key="tagIndex"
              type="button"
              class="remark_tag"
              :class="{ active: selectedDefaultRemarks.includes(tag) }"
              @click="toggleDefaultRemark(tag)"
            >
              {{ tag }}
            </button>
          </div>
          <textarea
            class="remark_textarea"
            v-model.trim="customRemarkInput"
            maxlength="100"
            placeholder="请输入备注"
          ></textarea>
          <van-button
            class="remark_confirm_btn"
            color="#00C2C2"
            round
            block
            @click="confirmRemarkModal"
            >确定</van-button
          >
        </div>
        <van-icon
          name="close"
          class="remark_close_btn"
          color="#fff"
          size="30"
          @click="closeRemarkModal"
        />
      </div>
    </van-overlay>
    <!-- 选择套餐弹窗 -->
    <van-popup round v-model="showSelectSetmealModal" position="center">
      <div class="overlay_con">
        <div class="select_specifications_con">
          <p class="goo_name van-ellipsis">{{ setMealInfo.GoodsName }}</p>
          <div class="setmeal_dialog_con">
            <div v-for="mItem in setMealInfo.MenuGoods" :key="mItem.GoodsId">
              <div class="c-lightgrey setmeal_group_title">
                {{ mItem.GroupName }}
              </div>
              <ul class="setmeal_group_con">
                <van-card
                    :desc="mItem.Description"
                    :title="mItem.GoodsName"
                    :thumb="mItem.PicUrl ? mItem.PicUrl : $root.defaultImg"
                    :num="mItem.num"
                  >
                    <template #price>
                      <p class="c-orange">
                        ￥{{ mItem.Price
                        }}<i v-if="mItem.Unit"> /{{ mItem.Unit }}</i>
                      </p>

                      <div class ="GoodsChangeItems" 
                      v-if="mItem.GoodsChangeItems&&mItem.GoodsChangeItems.length>0"
                      @click="changeGoodsChangeItems(mItem)"
                      >更换菜品</div>

                    </template>

                  </van-card>
              </ul>
            </div>
          </div>
          <div class="c-f-center c-m-t-30 c-m-b-20">
            <div class="c-m-r-15 w-140">
              <van-button
                color="#CCA567"
                plain
                round
                size="small"
                block
                @click="showSelectSetmealModal = false"
                >取消</van-button
              >
              <!-- <my-button btnTitle="取消" widthData="120px" paddingData="8px 12px" bgColor="#fff"
							borderData="1px solid #DEDEDE" color="#DEDEDE"
							@handleClickBtnFunc="isTableNumberShow=false">

						</my-button> -->
            </div>
            <div class="w-140">
              <van-button
                color="#CCA567"
                round
                block
                size="small"
                @click="handleSubmitSetmeal('add')"
                >确定</van-button
              >
            </div>
          </div>
        
        </div>
      </div>
    </van-popup>


     <!-- 可换套餐数据 -->
    <van-popup round v-model="showGoodsChange" position="center">
      <div class="overlay_con">
        <div class="select_specifications_con">
          <p class="goo_name van-ellipsis">更换菜品-{{ goodsChangeInfo.GoodsName }}</p>
          <div class="setmeal_dialog_con">
            <div v-for="mItem in goodsChangeInfo.GoodsChangeItems" :key="mItem.DesGoodsId">
              <div class="c-lightgrey setmeal_group_title">
                {{ mItem.GroupName }}
              </div>
              <ul class="setmeal_group_con">
                <van-card
                    class="goods_change_card"
                    :class="{
                      active: selectedGoodsChangeId === mItem.DesGoodsId,
                    }"
                    :desc="mItem.Description"
                    :title="mItem.DesGoodsName"
                    :thumb="mItem.PicUrl ? mItem.PicUrl : $root.defaultImg"
                    :num="mItem.num"
                    @click="selectGoodsChangeItem(mItem)"
                  >
                    <template #price>
                      <p class="c-orange">
                        ￥{{ mItem.Price||0
                        }}<i v-if="mItem.Unit"> /{{ mItem.Unit }}</i>
                      </p>

                
                    </template>
                    <template #num>
                      <div
                        class="goods_change_selected"
                        v-if="selectedGoodsChangeId === mItem.DesGoodsId"
                      >
                        <van-icon name="success" />已选
                      </div>
                    </template>

                  </van-card>
              </ul>
            </div>
          </div>
          <div class="c-f-center c-m-t-30 c-m-b-20">
            <div class="c-m-r-15 w-140">
              <van-button
                color="#CCA567"
                plain
                round
                size="small"
                block
                @click="showGoodsChange = false"
                >取消</van-button
              >
   
            </div>
            <div class="w-140">
              <van-button
                color="#CCA567"
                round
                block
                size="small"
                @click="handleSubmitGoodsChange()"
                >确定</van-button
              >
            </div>
          </div>
      
        </div>
      </div>
    </van-popup>


    <van-popup
      class="shop_cart_con vpn_list_con"
      round
      v-model="showSelectVpnModal"
      position="bottom"
      :close-on-click-overlay="false"
    >
      <div class="cartTitle">
        <span> 请选择门店 </span>
        <span
          ><van-icon
            size="22"
            color="#999"
            name="close"
            @click="handleCloseVpnPop"
        /></span>
      </div>
      <ul class="vpn_list_ul">
        <li
          v-for="item in vpnList"
          :key="item.SaaSCode"
          :class="item.SaaSCode == vpnInfo.code ? 'active' : ''"
          @click="handleSelectVpn(item)"
        >
          <img
            class="radio_icon"
            :src="item.SaaSCode == vpnInfo.code ? activeIcon : inactiveIcon"
            alt=""
          />
          <div class="vpn_right_con">
            <img :src="handleSetImg(item.Claims)" alt="" />
            <div>
              <p class="name_con">{{ item.Name }}</p>

              <p class="time_con">
                {{ item.BusinessStartTime }}-{{ item.BusinessEndTime }}
              </p>
              <p>
                {{ item.Address }}
              </p>
            </div>
          </div>
        </li>
      </ul>
    </van-popup>
    <van-popup
      class="shop_cart_con vpn_list_con"
      round
      v-model="showSelectDiningRoomModal"
      position="bottom"
      :close-on-click-overlay="false"
    >
      <div class="cartTitle">
        <span> 请选择餐厅 </span>
        <span
          ><van-icon
            size="22"
            color="#999"
            name="close"
            @click="handleCloseDiningRoomPop"
        /></span>
      </div>
      <ul class="vpn_list_ul">
        <li
          v-for="item in diningRoomList"
          :key="item.Id"
          :class="item.Id == diningRoomInfo.id ? 'active' : ''"
          @click="handleSelectDiningRoom(item)"
        >
          <img
            class="radio_icon"
            :src="item.Id == diningRoomInfo.id ? activeIcon : inactiveIcon"
            alt=""
          />
          <div class="vpn_right_con">
            <img :src="item.roomImg" alt="" />
            <div>
              <p class="name_con">{{ item.Name }}</p>

              <!-- <p class="time_con">
                {{ item.BusinessStartTime }}-{{ item.BusinessEndTime }}
              </p>
              <p>
                {{ item.Address }}
              </p> -->
            </div>
          </div>
        </li>
      </ul>
    </van-popup>

    <van-dialog
      v-model="showScanTipModal"
      title=""
      confirm-button-text="去扫码"
      class="scan_tip_con"
      @confirm="handleSubmitScanCode"
    >
      <van-icon
        name="close"
        class="close_btn"
        color="#DEDEDE"
        size="26"
        @click="showScanTipModal = false"
      />
      <p>请扫一扫餐桌上的点餐二维码，让我们知道您的就餐座位</p>
    </van-dialog>

    <van-overlay :show="showMealTipModal" z-index="5">
      <div class="overlay_con">
        <div class="select_specifications_con meal_tip_con">
          <div class="meal_tip_img">
            <img class="full_img" :src="mealTipImg" alt="" />
          </div>
          <van-icon
            name="close"
            class="close_btn_con"
            color="#fff"
            size="30"
            @click="showMealTipModal = false"
          />
        </div>
      </div>
    </van-overlay>
    <div class="micropointFooter">
      <div class="historyOrderEntry" @click="recordsConsumption">
        <div class="historyOrderIcon" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <span class="historyOrderText">点单记录</span>
      </div>
      <div class="shoppingCart" @click="joinedCarMask">
        <div class="commodity">
          <div class="carImg">
            <img
              class="full_img"
              src="@/assets/images/newShoppingCart.png"
              alt=""
            />
          </div>
          <a>购物车</a>
          <van-badge
            color="#AC8D5F"
            v-if="allNum > 0"
            :content="allNum"
            max="99"
          />
        </div>
        <div class="choose" v-if="allNum !== 0">
          <!-- <div class="empty" v-if="allNum === 0">
            {{ "购物车是空的快选购" }}
          </div> -->
          <div class="price">￥{{ allPrice }}</div>
        </div>
      </div>
      <van-button color="#333" round :disabled="allNum <= 0" @click="settlement"
        >点好了</van-button
      >
      <!-- <b :class="allNum > 0 && !IsNeedLocation ? '' : allNum> 0 && ((pointLimitDistance > 0 && distanceOfStore < pointLimitDistance) || pointLimitDistance === 0) ? 'dark-btn' : 'disable'"
      @click="settlement">结算</b> -->
    </div>
     
  </div>



</template>

<script>
import { Search, Badge, Popup, Dialog, Toast, ImagePreview } from "vant";
import BScroll from "better-scroll";
import {
  handleSessionStorage,
  handleTimeLocalStorage,
  handleScanCode,
} from "@/utils";
import {
  getDiningRoomList,
  getFoodList,
  getSetmealFoodInfo,
} from "@/api/foodOrder";
import { mapActions, mapState, mapGetters } from "vuex";
import { initConnect, handleSendMessage } from "@/utils/websorket";
import { EventBus } from "@/utils/eventbus";
import { verifyNeedWechatMember } from "@/utils/gFunc";
import PinyinMatch from "pinyin-match";
import goodListCard from "@/components/goodsListCard";

export default {
  name: "Micropoint",
  props: {},
  data() {
    return {
      RemarkIndex:0,
      RemarkChildIndex:0,
      savedRemark: '', // 存储保存的备注内容
      noticeList: [
        // { content: "新菜上新，快来体验吧~" },
        // { content: "热辣川菜，刺激你的味蕾" },
        // { content: "菜品多多，欢迎点餐" },
      ],
      yScroll: 0,
      scrollY: 0,
      catalog: 0,
      shortId: "",
      goodsList: [],
      goodsListOrigin: [],
      catalogListOrigin: [],
      catalogList: [],
      scrollTops: [],
      swipeList: [],
      maskType: false,
      scrollType: true,
      vpnCode: "",
      storeAddress: "",
      recommendGoodsList: [],
      searchKey: "",
      isInitScroll: true,
      hackMarginBottom: 0,
      distanceOfStore: 0, // 距当前店铺的距离>pointLimitDistance，不允许进行下单操作，避免恶意操作
      pointLimitDistance: 100, // 点单距离限制，超过限制不允许点单
      isUseMemberPrice: false, // 是否使用会员价结算
      timer: "",
      showSelectModal: false,
      foodInfo: {
        GoodsName: "",
        Specifications: [],
        MethodArray: [],
        TasteArray: [],
      },
      specificationInfo: { Id: null, TasteNameObj: {} },
      showRemarkModal: false,
      remarkGoodsItem: null,
      remarkAddFlag: "",
      remarkDefaultOptions: [],
      selectedDefaultRemarks: [],
      customRemarkInput: "",
      showSelectSetmealModal: false,
      setMealInfo: {},
      setmealObjInfo: {},
      showSelectVpnModal: false,
      vpnInfo: { name: "", code: "", id: null },
      vpnList: [],
      activeIcon: require("@/assets/radio/radio-active-2.png"),
      inactiveIcon: require("@/assets/radio/radio-unactive-2.png"),
      showScanTipModal: false,
      isGroupConfig: false,
      diningRoomList: [],
      diningRoomInfo: { name: "", code: "", id: null },
      showSelectDiningRoomModal: false,
      mealTipImg: "",
      showMealTipModal: false,
      showGoodsChange:false,
      goodsChangeInfo: {},
      selectedGoodsChangeId: null,
      selectedGoodsChangeInfo: {},
    };
  },
  components: {
    goodListCard,
  },
  created() {
    this.handleInitNoticeScroll();
    const deskCode = handleSessionStorage.get("deskCode");
    this.deskCode = deskCode && deskCode.code;
    this.teamId = handleSessionStorage.get("teamId");
    this.saasCode = this.$route.query.saasCode;
    this.diningRoomId = this.$route.query.diningRoomId;
    this.isSureVpn =true  //handleSessionStorage.get("isSureVpn"); //此时确认唯一门店,true时不可切换门店
    // 用于判断是否选择过门店
    const vpnStorage = handleSessionStorage.get("vpnInfo");
    this.preVpnInfo = vpnStorage;
    // 从公众号进入且未选择过门店则弹出选择门店弹窗
    // this.showSelectVpnModal = !this.saasCode && !vpnStorage;

    this.diningRoomId= handleSessionStorage.get("diningRoomId");
    this.preDiningRoomId =  this.diningRoomId;
    //进入时未选择过餐厅则弹出选择餐厅弹窗
    // this.showSelectDiningRoomModal = !this.diningRoomId && !diningRoomIdStore;
    // 加载商品列表
    this.handleGetVpnList();

    // this.handleGetDiningRoomList();
    // setTimeout(() => {
    //   this.handlePlusNum(
    //     { Id: 299793405, SpecificId: 1110 },
    //     // { Id: 299793400 },

    //     2,
    //     "isOtherPoint"
    //   );
    // }, 5000);
    // setTimeout(() => {
    //   this.handleMinusNum(
    //     { Id: 299793405, SpecificId: 1110 },
    //     // { Id: 299793400 },

    //     1,
    //     "isOtherPoint"
    //   );
    // }, 8000);
    // setTimeout(() => {
    //   this.handlePlusNum(
    //     { Id: 299793405, SpecificId: 1111 },
    //     // { Id: 299793400 },

    //     1,
    //     "isOtherPoint"
    //   );
    // }, 10000);
    // setTimeout(() => {
    //   this.handlePlusNum(
    //     // { Id: 299793405, SpecificId: 1111 },
    //     { Id: 299793400 },

    //     1,
    //     "isOtherPoint"
    //   );
    // }, 13000);
    // setTimeout(() => {
    //   this.handleMinusNum(
    //     // { Id: 299793405, SpecificId: 1111 },
    //     { Id: 299793400 },

    //     1,
    //     "isOtherPoint"
    //   );
    // }, 15000);
  },
  beforeRouteLeave(to, from, next) {
    EventBus.$off("getGroupGoodsList");
    EventBus.$off("getMessage");
    next();
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    // window.removeEventListener('scroll', this.handleScroll);
    clearTimeout(this.timer);
    if (this.interval) clearInterval(this.interval);
  },
  computed: {
    ...mapState({
      carGoodsList: (rootState) => rootState.shopCart.carGoodsList, //购物车中物品列表
    }),
    ...mapGetters("shopCart", {
      allNum: "allNum",
      allPrice: "allPrice",
      allCarGoodsArr: "allCarGoodsArr",
    }),
  },
  watch: {
    scrollY(newVal) {
      var scrolls = this.scrollTops;
      if (newVal >= scrolls[scrolls.length - 1]) {
        this.catalog = scrolls.length - 1;
        return;
      }
      for (var i = 0; i < scrolls.length; i++) {
        if (newVal >= scrolls[i] - 1 && newVal <= scrolls[i + 1] - 1) {
          this.catalog = i;
          return;
        }
      }
    },
  },
  methods: {
    ...mapActions("shopCart", {
      ADD_COUNT: "ADD_COUNT",
      MINUS_COUNT: "MINUS_COUNT",
      CLEAR_LIST: "CLEAR_LIST",
    }),
    closeModal(){
       this.isModalOpen = false;
    },

    /***更换菜品确认*/
    handleSubmitGoodsChange(){
     
     const index = this.setMealInfo.MenuGoods.findIndex((item) =>item.GoodsCode===this.goodsChangeInfo.GoodsCode)
      if(index!==-1){
        this.goodsChangeInfo.GoodsName = this.selectedGoodsChangeInfo.DesGoodsName
        this.goodsChangeInfo.GoodsCode = this.selectedGoodsChangeInfo.DesGoodsId
        this.goodsChangeInfo.GoodsId = this.selectedGoodsChangeInfo.GoodsId
        this.goodsChangeInfo.PicUrl = this.selectedGoodsChangeInfo.PicUrl
        this.goodsChangeInfo.Price = this.selectedGoodsChangeInfo.Price||0
        this.setMealInfo.MenuGoods[index] = this.goodsChangeInfo
      }
     this.showGoodsChange =false
     this.goodsChangeInfo = {}
     this.selectedGoodsChangeId = null
     this.selectedGoodsChangeInfo = {}
    },
    selectGoodsChangeItem(item) {
      this.selectedGoodsChangeId = item.DesGoodsId;
      this.selectedGoodsChangeInfo = item;
    },
    /**更换套餐菜品**/
    changeGoodsChangeItems(item){
      this.goodsChangeInfo = JSON.parse(JSON.stringify(item))
      this.selectedGoodsChangeId = null
      this.selectedGoodsChangeInfo = {}
      this.showGoodsChange =true
    },
    handleInitNoticeScroll() {
      this.originLength = this.noticeList.length;
      let count = 0;
      this.yScroll = 0;
      if (this.interval) clearInterval(this.interval);
      if (!this.noticeList.length || this.noticeList.length <= 1) return;
      this.interval = setInterval(() => {
        count += 1;
        if (count >= this.originLength) {
          count = 0;
          this.transition = "";
          this.yScroll = 0;
        } else {
          this.yScroll -= 40;
        }
      }, 2000);
    },
    // 点单记录
    recordsConsumption() {
      // 验证该场景是否需要强制注册微会员
      verifyNeedWechatMember(2, () => {
        this.$router.push({
          name: "RecordsConsumption",
        });
      });
    },
    handleGetVpnList() {
      $http(`wechath5/zh-cn/v1/vpn`).then((res) => {
        this.vpnList = res.Items;
        if (this.saasCode) {
          const vpnItem = this.vpnList.find(
            (item) => item.SaaSCode == this.saasCode
          );
          if (vpnItem) {
            console.log("vpnItem===== "+JSON.stringify(vpnItem))
            this.handleSubmitSelectVpn(vpnItem);
          }
        } else if (this.preVpnInfo) {
          const vpnItem = this.vpnList.find(
            (item) => item.SaaSCode == this.preVpnInfo.code
          );
          if (vpnItem) {
             console.log("handleSubmitSelectVpn===== "+JSON.stringify(vpnItem))
            this.handleSubmitSelectVpn(vpnItem);
          }
          //   this.vpnInfo={
          //   name:this.vpnList[0].Name,
          //   code:this.vpnList[0].SaaSCode,
          // }
        }

        // this.resetSetItem('websocketHistory', JSON.stringify(res.Items));
      });
    },
    handleGetDiningRoomList() {
      getDiningRoomList({ vpnId: this.vpnInfo.id }).then((res) => {
    
        if (!res || res.length == 0) {
          Toast("未获取到餐厅信息，请检查后台餐厅设置");
          return;
        }
        res.forEach((item) => {
          if (!item.ImageUrl || item.ImageUrl.length == 0) {
            item.roomImg = this.$root.defaultImg;
            item.banners = [];
          } else {
            const imgArr = item.ImageUrl.split(",");

            item.roomImg = item.CdnUrl + "/" + imgArr[0];
            item.banners = imgArr.map((iItem) => item.CdnUrl + "/" + iItem);
          }
          if (!item.TipImageUrl || item.TipImageUrl.length == 0) {
            item.tipBanners = [];
          } else {
            const imgArr = item.TipImageUrl.split(",");
            item.tipBanners = imgArr.map((iItem) => item.CdnUrl + "/" + iItem);
          }
        });
        this.diningRoomList = res;
        if (this.diningRoomId) {
          const vpnItem = this.diningRoomList.find(
            (item) => item.Id == this.diningRoomId
          );
          if (vpnItem) {
            this.handleSelectDiningRoom(vpnItem);
          }
        } else if (this.preDiningRoomId) {
          const vpnItem = this.diningRoomList.find(
            (item) => item.Id == this.preDiningRoomId
          );
          if (vpnItem) {
            this.handleSelectDiningRoom(vpnItem);
          }
        } else {
          this.handleSelectDiningRoom(this.diningRoomList[0]);
        }
      });
    },
    handleSetImg(claims) {
      if (claims.length == 0) {
        return this.$root.defaultImg;
      }
      let zeroItem = claims.find((v) => {
        return v.TypeId === 0;
      });
      if (zeroItem) {
        return zeroItem.CdnUrl + "/" + zeroItem.Value;
      } else {
        return this.$root.defaultImg;
      }
    },
    handleSetDiningRoomImg(cdnUrl, ImageUrl) {
      if (ImageUrl.length == 0) {
        return this.$root.defaultImg;
      }
      const imgArr = ImageUrl.split(",");
      return cdnUrl + "/" + imgArr[0];
    },
    handleShowSelectVpn() {
      // 扫码进入时 不可切换门店
      //if (this.saasCode || this.isSureVpn) return;
      this.showSelectVpnModal = true;
    },
    handleCloseVpnPop() {
      if (!this.vpnInfo.code) {
        Toast("请先选择门店");
        return;
      }
      this.showSelectVpnModal = false;
    },
    handleSelectVpn(item) {
      if (this.vpnInfo.code) {
        Dialog.confirm({
          message: "切换门店将清除已点餐品，确认切换吗？",
        }).then(() => {
          // on confirm
          this.searchKey = "";
          // 清空购物车
          this.handleClearCartGoods();
          if (this.isGroupConfig && this.isSureVpn) {
            handleSendMessage("SendGoodsClear", {
              TeamId: this.teamId,
              duration: this.vpnInfo.OrderTeamDuration,
            });
          }
          this.handleSubmitSelectVpn(item, "second");
        });
      } else {
        this.handleSubmitSelectVpn(item);
      }
    },
    handleShowSelectDiningRoom() {
      // 扫码进入时 不可切换餐厅
      // if (this.saasCode || this.isSureVpn) return;
      this.showSelectDiningRoomModal = false;
    },
    handleCloseDiningRoomPop() {
      if (!this.diningRoomInfo.id) {
        Toast("请先选择餐厅");
        return;
      }
      this.showSelectDiningRoomModal = false;
    },
    handleSelectDiningRoom(item) {
      if (this.diningRoomInfo.id) {
        Dialog.confirm({
          message: "切换门店将清除已点餐品，确认切换吗？",
        }).then(() => {
          // on confirm
          this.searchKey = "";
          // 清空购物车
          this.handleClearCartGoods();
          if (this.isGroupConfig && this.isSureVpn) {
            handleSendMessage("SendGoodsClear", {
              TeamId: this.teamId,
              duration: this.vpnInfo.OrderTeamDuration,
            });
          }
          this.handleSubmitSelectDiningRoom(item, "second");
        });
      } else {
        this.handleSubmitSelectDiningRoom(item);
      }
    },
    handleSubmitSelectVpn(item, flag) {
      this.vpnInfo = {
        name: item.Name,
        code: item.SaaSCode,
        id: item.Id,
        ...item.SaasVpnSetting,
        // payAfterMeal: item.SaasVpnSetting.PayAfterMeal,
        // wechatPayChannel: item.SaasVpnSetting.WechatPayChannel,
        // enableTeamOrder: item.SaasVpnSetting.EnableTeamOrder,
        // orderTeamDuration: item.SaasVpnSetting.OrderTeamDuration,
        // TableLedger: firstVpn.SaasVpnSetting.TableLedger,
        // 			GetPhoneByAppAuth: firstVpn.SaasVpnSetting.GetPhoneByAppAuth,
        // 			payAfterMeal: firstVpn.SaasVpnSetting.PayAfterMeal,
      };


      handleSessionStorage.set("vpnInfo", this.vpnInfo);
      this.showSelectVpnModal = false;
      this.isGroupConfig = handleSessionStorage.get("EnableTeamOrder");
      this.handleGetDiningRoomList();
    },
    handleSubmitSelectDiningRoom(item, flag) {
      this.diningRoomInfo = {
        name: item.Name,
        id: item.Id,
      };
      this.swipeList = item.banners;
      this.mealTipImg = item.tipBanners.length > 0 ? item.tipBanners[0] : "";
      this.showMealTipModal = !!this.mealTipImg;
      handleSessionStorage.set("diningRoomId", item.Id);
      handleSessionStorage.set("diningRoomInfo", item);
      this.showSelectDiningRoomModal = false;

      console.log("isGroupConfigisGroupConfigisGroupConfig ==== "+this.isGroupConfig)
      console.log("isSureVpnisSureVpnisSureVpn ==== "+this.isSureVpn)

      if (this.isGroupConfig && this.isSureVpn) {
        this.handleInitConnet();
         this.getGoodsList(flag);
      } else {
        // 加载商品列表
        this.getGoodsList(flag);
      }
      // this.isGroupConfig = item.SaasVpnSetting.EnableTeamOrder;
      // if (this.isGroupConfig && this.isSureVpn) {
      //   this.handleInitConnet();
      // } else {
      // 加载商品列表
      // this.getGoodsList(flag);
      // }
    },
    handleInitConnet() {
      // 建立连接
      initConnect();
      if (this.$store.state.pointConnet) {
        handleSendMessage("SendGoodsList", {
          TeamId: this.teamId,
          duration: this.vpnInfo.OrderTeamDuration,
        });
      }
      EventBus.$on("getMessage", (data) => {
        // 接收服务端发送来的消息
        console.log("点单页成功收到了-------------", data);
        if (data.Quantity > 0) {
          //   //某商品增加了
          this.handlePlusNum(data, data.Quantity, "isOtherPoint");
        } else {
          this.handleMinusNum(data, -data.Quantity, "isOtherPoint");
        }
      });
      EventBus.$on("getGroupGoodsList", (data, isClear) => {
        // 接收服务端发送来的消息
        console.log("点单页初始列表收到了-------------", data);

        // this.carGoodsList = goodsArr;
        // 初始化购物车商品
        this.$store.commit("shopCart/initCardList", data);
        if (isClear) {
          this.handleClearCartGoods();
        } else {
          // 加载商品列表
          this.getGoodsList();
        }
      });
      // this.getGoodsList();
    },
    getGoodsList(flag) {
      this.catalogList = [];
      this.goodsList = [];
      getFoodList({
        code: this.vpnInfo.code,
        diningRoomId: this.diningRoomInfo.id,
        vpnId: this.vpnInfo.id,
      }).then((res) => {
        let allFoodsList = [];
        if (this.allCarGoodsArr.length > 0) {
          res.forEach((item, index) => {
            // const shortCutItem = item.ShortCutItem
            const itemGoodsList = item.Goods;
            if (itemGoodsList && itemGoodsList.length > 0) {
              itemGoodsList.forEach((goodsItem) => {
                allFoodsList.push(goodsItem.Id);
              });
            }
          });
        }
        res.forEach((item, index) => {
          // const shortCutItem = item.ShortCutItem
          const itemGoodsList = item.Goods;
          const catalog = {
            id: item.GoodsCatalogId,
            name: item.GoodsCatalogName,
            // helpName:item.HelpName,
            num: 0,
          };
          if (itemGoodsList && itemGoodsList.length > 0) {
            // 若之前缓存的餐品不存在或已售罄，需要清除购物车中无效的餐品
            if (this.allCarGoodsArr.length > 0) {
              this.allCarGoodsArr.forEach((carItem) => {
                const findGoodItems = allFoodsList.find(
                  (idItem) => carItem.Id == idItem
                );
                // 切换后的门店若没有某种商品或有但已售罄，则清除购物车中对应的商品
                if (
                  !findGoodItems ||
                  (findGoodItems.IsSellOut && findGoodItems.SellOutNumber === 0)
                ) {
                  this.$store.commit("shopCart/removeFoodItem", {
                    userInfo: { userId: 1, name: "我" },
                    idData: carItem.Id,
                  });
                }
              });
            }
            itemGoodsList.forEach((goodsItem) => {
              goodsItem.num = 0;
              // 多规格时初始每种规格的数量0
              if (goodsItem.IsMultiSpecific) {
                let minPrice = goodsItem.Specifications[0].Price;
                goodsItem.Specifications.forEach((sItem) => {
                  sItem.num = 0;
                  if (sItem.Price < minPrice) {
                    minPrice = sItem.Price;
                  }
                });
                goodsItem.Price = minPrice;
              }
              // 根据购物车缓存初始化商品列表和分类数量展示
              for (let userId in this.carGoodsList) {
                const nowList = this.carGoodsList[userId].list;
                const findGoodItems = nowList.filter(
                  (carItem) => carItem.Id == goodsItem.Id
                );
                if (findGoodItems.length > 0) {
                  //
                  findGoodItems.forEach((findItem) => {
                    // 先初始化商品列表中数量
                    goodsItem.num += findItem.num;
                    //再初始化 商品的各个规格的数量
                    if (goodsItem.IsMultiSpecific) {
                      const specificItem = goodsItem.Specifications.findIndex(
                        (specItem) => specItem.Id == findItem.SpecificId
                      );
                      if (specificItem != -1) {
                        goodsItem.Specifications[specificItem].num +=
                          findItem.num;
                      }
                    }
                  });
                }
              }
              catalog.num += goodsItem.num;
            });
            this.catalogList.push(catalog);
            this.goodsList.push(itemGoodsList);
          }
        });
        this.catalogListOrigin = this.catalogList;
        this.goodsListOrigin = this.goodsList;
        // 测试推荐数据，还需调整
        // this.recommendGoodsList =
        //   this.goodsList.length > 0 ? this.goodsList[0] : [];
        this.$nextTick(() => {
          this.calculateHeight();
          if (this.goodsList.length > 0) {
            const allHeight = document.querySelector(
              ".micropointGoodsList"
            ).clientHeight;
            console.log("高度==" + allHeight);
            const lastHeight = document.querySelector(".lastList").clientHeight;
            console.log("最后的高度==" + lastHeight);
            const heightSpace = allHeight - lastHeight;
            this.hackMarginBottom = heightSpace > 0 ? heightSpace : 0;
          } else {
            this.hackMarginBottom = 0;
          }

          this.$nextTick(() => {
            if (this.isInitScroll) {
              this.scrollInit(); // 多次初始化滚动事件会导致，数量加减的click事件重复执行
              this.isInitScroll = false;
            }
          });
          if (flag == "second") {
            handleSessionStorage.remove("menuIndex");
            this.catalogStyle(0);
          } else {
            // 记录点击位置， 在返回时候调用
            this.timer = setTimeout(() => {
              const idx = handleSessionStorage.get("menuIndex");
              idx && this.catalogStyle(idx);
            }, 300);
          }
        });
      });
    },
    // 计算商品列表高度 用于滚动定位
    calculateHeight() {
      this.scrollTops = [];
      const bigList = this.$refs.menuList.getElementsByClassName("bigList");
      let height = 0;
      this.scrollTops.push(height);
      for (let i = 0; i < bigList.length; i++) {
        height += bigList[i].clientHeight;
        this.scrollTops.push(height);
      }
    },
    scrollInit() {
      this.menuScroll = new BScroll(this.$refs.menu, {
        click: true,
      });
      this.goodsScroll = new BScroll(this.$refs.menuList, {
        click: true,
        probeType: 3,
      });
      // this.scrollType = true;
      this.goodsScroll.on("scroll", (pos) => {
        this.scrollY = Math.abs(Math.round(pos.y));
      });
    },
    // 点击左侧分类
    catalogStyle(index) {
      this.$nextTick(() => {
        this.catalog = index;
        this.goodsScroll.scrollTo(0, -this.scrollTops[index], 100);

        handleSessionStorage.set("menuIndex", index);
      });
    },
    // 点击菜品图片放大预览
    previewGoodsImg(item) {
      const url = item.PicUrl || this.$root.defaultImg;
      if (!url) return;
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },
    // 跳转到商品详情页
    selfHelpPointDetails(item) {
      // this.messageCache();
      // timeStorage.set('microGoodsDetail', item, 1000 * 60 * 30);
      // this.$router.push({
      //   name: 'SelfHelpPointDetails',
      //   params: {
      //     GoodsId: item.GoodsId
      //   }
      // });
    },
    onSubmit() {
      this.onSearch();
    },
    onSearch() {
      const filteredGoodsList = [];
      const filteredCatalogList = [];
      if (this.searchKey.length > 0) {
        this.goodsListOrigin.map((item, index) => {
          filteredGoodsList[index] = item.filter((subItem) => {
            return PinyinMatch.match(subItem.GoodsName, this.searchKey);
          });
        });
        this.goodsList = filteredGoodsList.filter((item) => item.length > 0);
      } else {
        this.goodsList = this.goodsListOrigin;
      }
      this.catalogListOrigin.map((item) => {
        this.goodsList.map((subItem) => {
          if (item.id === subItem[0].GoodsCatalogId) {
            filteredCatalogList.push(item);
          }
        });
      });
      this.catalogList = filteredCatalogList;
      this.$nextTick(() => {
        this.calculateHeight();
      });
    },
    // handleChangeGoodItemNum(value){
    //   console.log(value)
    // let catatypeItem=this.catalogList.find(typeItem=>typeItem.id==item.CustomCatalogId)

    // if(value>item.num){//增加
    //   catatypeItem.num+=value
    // }else{
    //   catatypeItem.num-=value
    // }

    // },
    normalizeGoodsRemarkArray(value) {
      if (Array.isArray(value)) {
        return value.map((item) => String(item).trim()).filter(Boolean);
      }
      if (typeof value === "string") {
        return value
          .split(/[,，]/)
          .map((item) => item.trim())
          .filter(Boolean);
      }
      return [];
    },
    /** 是否有商品备注（有则列表展示「选规格」，不展示 + 号） */
    hasGoodsRemark(item) {
      if (!item) return false;
      return this.normalizeGoodsRemarkArray(item.GoodsRemarkArray).length > 0;
    },
    openRemarkModal(item, flag) {
      this.remarkGoodsItem = item;
      this.remarkAddFlag = flag || "";
      this.remarkDefaultOptions = this.normalizeGoodsRemarkArray(
        item.GoodsRemarkArray
      );
      this.selectedDefaultRemarks = [];
      this.customRemarkInput = "";
      this.showRemarkModal = true;
    },
    closeRemarkModal() {
      this.showRemarkModal = false;
      this.remarkGoodsItem = null;
      this.remarkAddFlag = "";
      this.remarkDefaultOptions = [];
      this.selectedDefaultRemarks = [];
      this.customRemarkInput = "";
    },
    toggleDefaultRemark(tag) {
      if (!tag) return;
      const index = this.selectedDefaultRemarks.indexOf(tag);
      if (index >= 0) {
        this.selectedDefaultRemarks.splice(index, 1);
      } else {
        this.selectedDefaultRemarks.push(tag);
      }
    },
    confirmRemarkModal() {
      if (!this.remarkGoodsItem) {
        this.closeRemarkModal();
        return;
      }
      const remarkText = [
        ...this.selectedDefaultRemarks,
        this.customRemarkInput,
      ]
        .filter(Boolean)
        .join(",");
      const sourceItem = this.remarkGoodsItem;
      const flag = this.remarkAddFlag;
      this.closeRemarkModal();

      // 有备注商品：每次弹框确定后购物车固定加 1
      // 使用拷贝写入备注，避免不同备注共用列表对象上的旧 num/备注导致串行
      const stepNum = 1;
      const item = {
        ...sourceItem,
        CustomRemark: remarkText,
        remark: remarkText,
        num: sourceItem.num || 0,
      };
      if (
        item.IsSellOut &&
        item.SellOutNumber != null &&
        (item.num || 0) + stepNum > item.SellOutNumber
      ) {
        return this.$toast("添加数量超过餐品沽清数量，无法添加哦");
      }
      if (
        item.RestrictionCount &&
        item.num + stepNum > item.RestrictionCount
      ) {
        return this.$toast("添加数量超过餐品限点数量，无法添加哦");
      }
      // 列表总数量仍累加到原商品上，便于分类角标统计
      this.$set(sourceItem, "num", (sourceItem.num || 0) + stepNum);
      this.handlePlusNum(item, stepNum, flag);
      if (this.isGroupConfig && this.isSureVpn) {
        const param = {
          TeamId: this.teamId,
          Quantity: stepNum,
          TableCode: this.deskCode,
          VpnId: this.vpnInfo.id,
          duration: this.vpnInfo.OrderTeamDuration,
          GoodsCatalog: item.GoodsCatalog,
          GoodsCatalogId: item.GoodsCatalogId,
          GoodsName: item.GoodsName,
          Id: item.Id,
          IsMultiSpecific: item.IsMultiSpecific || false,
          PicUrl: item.PicUrl,
          Price: item.Price,
          MinBuyCount: item.MinBuyCount,
          remark: item.remark,
        };
        if (item.IsMultiSpecific) {
          param.SpecificId = item.SpecificId;
          param.Specification = item.Name;
        }
        if (item.MethodName) {
          param.DoWay = item.MethodName;
        }
        if (item.TasteNameObj && Object.keys(item.TasteNameObj).length > 0) {
          param.Taste = Object.keys(item.TasteNameObj).sort().join(",");
        }
        handleSendMessage("SendChangeGoods", param);
      }
    },
    // 点击添加或减少商品
    handleSetGoodsAndPrice(item, type, flag) {
      console.log("点击添加");
      console.log(item);
      if (type == "add") {
        if (
          item.IsSellOut &&
          item.SellOutNumber != null &&
          item.MinBuyCount &&
          item.num + item.MinBuyCount > item.SellOutNumber
        ) {
          return this.$toast("添加数量超过餐品沽清数量，无法添加哦");
        }

       const currentNum =  item.num||0
       if(item.IsServiceId==6&&currentNum==0){
        this.setMealInfo = item
        this.showSelectSetmealModal = true
        return
       }

        // 有备注商品走「选规格」入口，这里兜底再弹一次备注框
        if (
          this.hasGoodsRemark(item) &&
          flag !== "cart" &&
          flag !== "modal" &&
          flag !== "isOtherPoint" &&
          flag !== "remarkConfirmed"
        ) {
          this.openRemarkModal(item, flag);
          return;
        }

        // const stepNum=item.num?item.StepNum:item.MinNum
        const stepNum = item.num ? 1 : item.MinBuyCount ? item.MinBuyCount : 1;
        if (
          item.RestrictionCount &&
          item.num + stepNum > item.RestrictionCount
        ) {
          return this.$toast("添加数量超过餐品限点数量，无法添加哦");
        }
        this.handlePlusNum(item, stepNum, flag);
        if (this.isGroupConfig && this.isSureVpn) {
          const param = {
            // ...item,
            TeamId: this.teamId,
            Quantity: stepNum,
            TableCode: this.deskCode,
            VpnId: this.vpnInfo.id,
            duration: this.vpnInfo.OrderTeamDuration,
            GoodsCatalog: item.GoodsCatalog,
            GoodsCatalogId: item.GoodsCatalogId,
            GoodsName: item.GoodsName,
            Id: item.Id,
            IsMultiSpecific: item.IsMultiSpecific || false,
            PicUrl: item.PicUrl,
            Price: item.Price,
            MinBuyCount: item.MinBuyCount,
            remark:item.remark,
          };
          if (item.IsMultiSpecific) {
            param.SpecificId = item.SpecificId;
            param.Specification = item.Name;
          }
          if (item.MethodName) {
            param.DoWay = item.MethodName;
          }
          if (item.TasteNameObj && Object.keys(item.TasteNameObj).length > 0) {
            param.Taste = Object.keys(item.TasteNameObj).sort().join(",");
          }
          handleSendMessage("SendChangeGoods", param);
        }
      } else {
        // 减少数量时 若所剩余数量少于每次需要减少的步数，则只减少当前苏剩余数量
        // const stepNum=item.num-item.StepNum<0?item.num:item.StepNum
        console.log(item.MinBuyCount, item.num);
        const stepNum =
          !item.MinBuyCount || item.num - item.MinBuyCount > 0
            ? 1
            : item.MinBuyCount;

        // item.num - 1 < 0 ? item.num : 1;
        this.handleMinusNum(item, stepNum, flag);
        if (this.isGroupConfig && this.isSureVpn) {
          const param = {
            // ...item,
            TeamId: this.teamId,
            Quantity: -stepNum,
            TableCode: this.deskCode,
            VpnId: this.vpnInfo.id,
            duration: this.vpnInfo.OrderTeamDuration,
            GoodsCatalog: item.GoodsCatalog,
            GoodsCatalogId: item.GoodsCatalogId,
            GoodsName: item.GoodsName,
            Id: item.Id,
            IsMultiSpecific: item.IsMultiSpecific || false,
            PicUrl: item.PicUrl,
            Price: item.Price,
            MinBuyCount: item.MinBuyCount,
            remark:item.remark,
          };
          if (item.IsMultiSpecific) {
            param.SpecificId = item.SpecificId;
            param.Specification = item.Name;
          }
          if (item.MethodName) {
            param.DoWay = item.MethodName;
          }
          if (item.TasteNameObj && Object.keys(item.TasteNameObj).length > 0) {
            param.Taste = Object.keys(item.TasteNameObj).sort().join(",");
          }
          handleSendMessage("SendChangeGoods", param);
        }
      }
    },
    // 增加
    handlePlusNum(item, stepNum, type) {
      console.log("+++++++++++++++");
      console.log(item, stepNum, type);
      // 多人点餐时，其他人点了餐品
      if (type == "isOtherPoint") {
        // var allGoodsList = this.goodsList.reduce(function (a, b) { return a.concat(b)} );
        // if(item.IsMultiSpecific){
        //   const goodsIndex = allGoodsList.find(
        //   (goodsItem) => goodsItem.Id == item.Id
        // );
        // }
        // 当其他人点了某个餐品，先查找他人点餐的餐品种类，并给item重新赋值
        this.goodsList.forEach((outItem) => {
          const goodsIndex = outItem.findIndex(
            (goodsItem) => goodsItem.Id == item.Id
          );
          if (goodsIndex != -1) {
            if (outItem[goodsIndex].IsMultiSpecific) {
              const specificItem = outItem[goodsIndex].Specifications.findIndex(
                (specItem) => specItem.Id == item.SpecificId
              );
              if (specificItem != -1) {
                //  const cartItem= this.allCarGoodsArr.find(carItem=>{
                //   if(item.Taste){
                //    return carItem.Id ==  item.Id&&carItem.SpecificId == item.SpecificId&&carItem.Taste==item.Taste)
                //   }else if(item.DoWay){
                //    return carItem.Id ==  item.Id&&carItem.SpecificId == item.SpecificId&&carItem.DoWay==item.DoWay)

                //   }
                //  })

                // outItem[goodsIndex].Specifications[specificItem].num += stepNum;
                // 若规格弹窗正在展示，则更新弹窗中对应规格的数量
                // if (
                //   this.showSelectModal &&
                //   this.specificationInfo.SpecificId == item.SpecificId
                // )
                //   this.handleSelectSpecific(
                //     outItem[goodsIndex].Specifications[specificItem]
                //   );
                const { Id, ...resetItem } = outItem[goodsIndex];
                let tasteObj = {};
                if (item.Taste) {
                  const tasteArr = item.Taste.split(",");
                  tasteArr.forEach((tItem) => {
                    tasteObj[tItem] = tItem;
                  });
                }
                item = Object.assign(
                  {},
                  resetItem,
                  // outItem[goodsIndex].Specifications[specificItem],
                  {
                    Id,
                    SpecificId: item.SpecificId,
                    Name: item.Specification,
                    Price: item.Price,
                    MethodName: item.DoWay || "",
                    TasteNameObj: tasteObj,
                    num: stepNum,
                    remark:item.remark
                  }
                );
              }
            } else if (item.DoWay || item.Taste) {
              const { Id, ...resetItem } = outItem[goodsIndex];
              let tasteObj = {};
              if (item.Taste) {
                const tasteArr = item.Taste.split(",");
                tasteArr.forEach((tItem) => {
                  tasteObj[tItem] = tItem;
                });
              }
              item = Object.assign(
                {},
                resetItem,
                 {
                  Id,
                  MethodName: item.DoWay || "",
                  TasteNameObj: tasteObj,
                  num: stepNum,
                }
              );
            } else {
              // outItem[goodsIndex].num += stepNum;
              item = outItem[goodsIndex];
            }
          }
        });
      } else {
        item.num += stepNum;
      }

      this.$nextTick(() => {
        let catatypeItem = this.catalogList.find(
          (typeItem) => typeItem.id == item.GoodsCatalogId
        );
        catatypeItem.num += stepNum;
        if (type == "cart") {
          this.handleAddGoodslistCount({ item, stepNum });
        } else {
          if (type == "modal" || type == "isOtherPoint") {
            this.handleAddGoodslistCount({ item, stepNum, type });
          }
          console.log("不改购物车");
          console.log(item);
          // 修改购物车中商品列表
          this.ADD_COUNT({
            userInfo: { userId: 1, name: "我" },
            item,
            stepNum,
          });
        }
      });
    },
    // 减少
    handleMinusNum(item, stepNum, type) {
      if (type == "isOtherPoint") {
        // var allGoodsList = this.goodsList.reduce(function (a, b) { return a.concat(b)} );
        // if(item.IsMultiSpecific){
        //   const goodsIndex = allGoodsList.find(
        //   (goodsItem) => goodsItem.Id == item.Id
        // );
        // }
        this.goodsList.forEach((outItem) => {
          const goodsIndex = outItem.findIndex(
            (goodsItem) => goodsItem.Id == item.Id
          );
          if (goodsIndex != -1) {
            if (outItem[goodsIndex].IsMultiSpecific) {
              const specificItem = outItem[goodsIndex].Specifications.findIndex(
                (specItem) => specItem.Id == item.SpecificId
              );

              if (specificItem != -1) {
                // if (
                //   outItem[goodsIndex].Specifications[specificItem].num -
                //     stepNum >
                //   0
                // ) {
                //   outItem[goodsIndex].Specifications[specificItem].num -=
                //     stepNum;
                // } else {
                //   outItem[goodsIndex].Specifications[specificItem].num = 0;
                // //从购物车清除该规格
                // this.$store.commit("shopCart/removeSpecific", {
                //   userInfo: { userId: 1, name: "我" },
                //   item,
                // });
                // }
                // 若规格弹窗正在展示，则更新弹窗中对应规格的数量
                // if (
                //   this.showSelectModal &&
                //   this.specificationInfo.SpecificId == item.SpecificId
                // )
                //   this.handleSelectSpecific(
                //     outItem[goodsIndex].Specifications[specificItem]
                //   );
                // outItem[goodsIndex].Specifications[specificItem].num -= stepNum;
                const { Id, ...resetItem } = outItem[goodsIndex];
                let tasteObj = {};
                if (item.Taste) {
                  const tasteArr = item.Taste.split(",");
                  tasteArr.forEach((tItem) => {
                    tasteObj[tItem] = tItem;
                  });
                }
                item = Object.assign(
                  {},
                  resetItem,
                  // outItem[goodsIndex].Specifications[specificItem],
                  {
                    // Id,
                    // SpecificId: item.SpecificId,

                    // MethodName: item.DoWay,
                    // TasteNameObj: tasteObj,
                    Id,
                    SpecificId: item.SpecificId,
                    Name: item.Specification,
                    Price: item.Price,
                    MethodName: item.DoWay || "",
                    TasteNameObj: tasteObj,
                    // num: stepNum,
                  }
                );
              }
            } else if (item.DoWay || item.Taste) {
              const { Id, ...resetItem } = outItem[goodsIndex];
              let tasteObj = {};
              if (item.Taste) {
                const tasteArr = item.Taste.split(",");
                tasteArr.forEach((tItem) => {
                  tasteObj[tItem] = tItem;
                });
              }
              item = Object.assign(
                {},
                resetItem,

                {
                  Id,
                  MethodName: item.DoWay || "",
                  TasteNameObj: tasteObj,
                }
              );
            } else {
              // outItem[goodsIndex].num -= stepNum;
              item = outItem[goodsIndex];
            }
          }
        });
      } else {
        item.num -= stepNum;
      }
      this.$nextTick(() => {
        let catatypeItem = this.catalogList.find(
          (typeItem) => typeItem.id == item.GoodsCatalogId
        );
        if (catatypeItem) {
          catatypeItem.num = Math.max(0, catatypeItem.num - stepNum);
        }
        // 购物车中减少数量
        if (type == "cart") {
          this.handleMinusGoodslistCount({ item, stepNum });
          // 购物车数量减到 0 时删除当前商品行
          if (item.num <= 0) {
            this.MINUS_COUNT({
              userInfo: { userId: 1, name: "我" },
              item,
              stepNum,
              callback: () => {
                this.maskType = false;
              },
            });
          }
        } else {
          if (type == "modal" || type == "isOtherPoint") {
            this.handleMinusGoodslistCount({ item, stepNum, type });
          }
          // 修改购物车中商品列表
          this.MINUS_COUNT({
            userInfo: { userId: 1, name: "我" },
            item,
            stepNum,
            callback: () => {
              this.maskType = false;
            },
          });
        }
      });
    },
    // 从购物车/规格弹窗中/他人点餐 新增商品数量
    handleAddGoodslistCount(data) {
      const { stepNum, type } = data;
      const item = this.$pub.deepClone(data.item);
      this.goodsList.forEach((outItem) => {
        const goodsIndex = outItem.findIndex(
          (goodsItem) => goodsItem.Id == item.Id
        );
        if (goodsIndex != -1) {
          // 先添加商品列表的总数量
          outItem[goodsIndex].num += stepNum;
          // 添加某一种规格的数量
          if (type != "isOtherPoint") {
            // if (outItem[goodsIndex].IsMultiSpecific) {
            //   console.log("这是多规格的啊啊");
            //   const specificItem = outItem[goodsIndex].Specifications.findIndex(
            //     (specItem) => specItem.Id == item.SpecificId
            //   );
            //   if (specificItem != -1) {
            //     console.log("新增了啊啊");
            //     outItem[goodsIndex].Specifications[specificItem].num += stepNum;
            //   }
            // }
          }
        }
      });
      console.log(this.carGoodsList);
    },
    // 从购物车/规格弹窗中/他人点餐 减少商品数量
    handleMinusGoodslistCount(data) {
      const { stepNum, type } = data;
      console.log("从购物车/规格弹窗中/他人点餐 减少商品数量");
      const item = this.$pub.deepClone(data.item);
      for (let i = 0; i < this.goodsList.length; i++) {
        const outItem = this.goodsList[i];
        const goodsIndex = outItem.findIndex(
          (goodsItem) => goodsItem.Id == item.Id
        );
        if (goodsIndex == -1) {
          continue;
        }

        if (outItem[goodsIndex].num - stepNum > 0) {
          outItem[goodsIndex].num -= stepNum;
          if (type != "isOtherPoint") {
            if (outItem[goodsIndex].IsServiceId == 6) {
              //从购物车清除该套餐
              this.$store.commit("shopCart/removeMealItem", {
                userInfo: { userId: 1, name: "我" },
                item,
                stepNum,
              });
            } else if (outItem[goodsIndex].IsMultiSpecific) {
              // 减少餐品某一种规格的数量
              // const specificItem = outItem[goodsIndex].Specifications.findIndex(
              //   (specItem) => specItem.Id == item.SpecificId
              // );
              // if (specificItem != -1) {
              //   if (
              //     outItem[goodsIndex].Specifications[specificItem].num -
              //       stepNum >
              //     0
              //   ) {
              //     outItem[goodsIndex].Specifications[specificItem].num -=
              //       stepNum;
              //   } else {
              //     outItem[goodsIndex].Specifications[specificItem].num = 0;
              //从购物车清除该规格
              this.$store.commit("shopCart/removeSpecific", {
                userInfo: { userId: 1, name: "我" },
                item,
                stepNum,
              });
              // }
              // }
            } else if (item.TasteNameObj || item.MethodName) {
              console.log("减少口味或做法");
              this.$store.commit("shopCart/removeMethod", {
                userInfo: { userId: 1, name: "我" },
                item,
                stepNum,
              });
            }
          }
        } else {
          outItem[goodsIndex].num = 0;
          // 减少餐品某一种规格的数量
          if (type != "isOtherPoint") {
            if (outItem[goodsIndex].IsMultiSpecific) {
              // const specificItem = outItem[goodsIndex].Specifications.findIndex(
              //   (specItem) => specItem.Id == item.SpecificId
              // );
              // if (specificItem != -1) {
              //   outItem[goodsIndex].Specifications[specificItem].num = 0;
              // }
            }
          }
          // 当数量减为0时，从购物车中移除当前减少的商品
          this.MINUS_COUNT({
            userInfo: { userId: 1, name: "我" },
            item,
            stepNum,
            callback: () => {
              this.maskType = false;
            },
          });
        }
      }
    },
    handleShowSelectSpecific(item) {
      this.showSelectModal = true;
      this.foodInfo = item;

      // this.foodInfo = {
      //   GoodsName: "cesh",
      //   Specifications: [
      //     { Name: "大份", Id: 1, num: 0, Price: 0 },
      //     { Name: "中份", Id: 2, num: 0, Price: 0 },
      //     { Name: "小份", Id: 3, num: 0, Price: 0 },
      //   ],
      // };

      const nowItem = this.foodInfo.Specifications;
      const methodItem =
        this.foodInfo.MethodArray && this.foodInfo.MethodArray.length > 0
          ? this.foodInfo.MethodArray[0]
          : "";
      const { Id, ...resetItem } = item;
      this.specificationInfo.TasteNameObj = {};
      this.specificationInfo.MethodName = methodItem;
      let findItem;
      if (nowItem[0]) {
        findItem = this.handleFindPreSpecificGoods(nowItem[0].Id);
      } else {
        findItem = this.handleFindPreSpecificGoods();
      }

      this.specificationInfo = Object.assign({}, resetItem, nowItem[0], {
        Id,
        num: findItem ? findItem.num : 0,
        SpecificId: nowItem[0] ? nowItem[0].Id : null,
        MethodName: methodItem,
        TasteNameObj: {},
      });
    },
    handleSelectSpecific(item) {
      const { Id, ...resetItem } = item;
      this.specificationInfo.SpecificId = Id;
      // this.allCarGoodsArr.find((carItem) =>carItem.Id==this.foodInfo.Id&&carItem.SpecificId==Id);
      const findItem = this.handleFindPreSpecificGoods(Id);
      this.specificationInfo = Object.assign(
        {},
        this.specificationInfo,
        resetItem,
        {
          SpecificId: Id,
          num: findItem ? findItem.num : 0,
        }
      );
    },
    handleFindPreSpecificGoods(Id) {
      let findItem;
      const _this = this;
      for (let i = 0; i < this.allCarGoodsArr.length; i++) {
        const carItem = this.allCarGoodsArr[i];

        if (carItem.Id == this.foodInfo.Id) {
          // findItem = carItem;

          if (this.foodInfo.IsMultiSpecific) {
            if (carItem.SpecificId == Id) {
              // findItem = carItem;
              setMethodsAndTaste();
            } else {
              findItem = null;
            }
          } else {
            setMethodsAndTaste();
          }

          function setMethodsAndTaste() {
            if (
              _this.specificationInfo.MethodName &&
              _this.specificationInfo.TasteNameObj &&
              carItem.TasteNameObj
            ) {
              console.log("口味和做法都有");
              console.log(_this.specificationInfo.MethodName);
              console.log(carItem.MethodName);
              console.log(carItem.TasteNameObj);
              console.log(_this.specificationInfo.TasteNameObj);
              console.log(
                _this.equalsObj(
                  carItem.TasteNameObj,
                  _this.specificationInfo.TasteNameObj
                )
              );
              if (
                _this.specificationInfo.MethodName == carItem.MethodName &&
                _this.equalsObj(
                  carItem.TasteNameObj,
                  _this.specificationInfo.TasteNameObj
                )
              ) {
                console.log("口味和做法相同");
                findItem = carItem;
              } else {
                findItem = null;
              }
            } else if (_this.specificationInfo.MethodName) {
              console.log("做法");
              if (_this.specificationInfo.MethodName == carItem.MethodName) {
                findItem = carItem;
              } else {
                findItem = null;
              }
            } else if (
              _this.specificationInfo.TasteNameObj &&
              carItem.TasteNameObj
            ) {
              console.log("口味");
              if (
                _this.equalsObj(
                  carItem.TasteNameObj,
                  _this.specificationInfo.TasteNameObj
                )
              ) {
                findItem = carItem;
              } else {
                findItem = null;
              }
            } else {
              findItem = carItem;
            }
          }
          if (findItem) {
            break;
          }
        }
      }
      console.log("从购物车中查找到的规格、口味、做法数据");
      console.log(findItem);
      return findItem;
    },
    equalsObj(a, b) {
      // 判断两个对象是否指向同一内存，指向同一内存返回 true
      // if (a === b) return true // 获取两个对象键值数组
      let aProps = Object.getOwnPropertyNames(a);
      let bProps = Object.getOwnPropertyNames(b);

      // 判断两个对象键值数组长度是否一致，不一致返回 false
      if (aProps.length !== bProps.length) return false; // 遍历对象的键值
      for (let prop in a) {
        // 判断 a 的键值，在 b 中是否存在，不存在，返回 false
        if (b.hasOwnProperty(prop)) {
          // 判断 a 的键值是否为对象，是则递归，不是对象直接判断键值是否相等，不相等返回 false
          if (typeof a[prop] === "object") {
            if (!this.equalsObj(a[prop], b[prop])) return false;
          } else if (a[prop] !== b[prop]) {
            return false;
          }
        } else {
          return false;
        }
      }
      return true;

      // let ArrayA = Object.getOwnPropertyNames(a);
      // let ArrayB = Object.getOwnPropertyNames(b);

      // if (ArrayA.length != ArrayB.length) return false;
      // for (let i = 0; i < ArrayA.length; i++) {
      //   let propNameA = ArrayA[i];
      //   let propNameB = ArrayB[i];

      //   if (!a.hasOwnProperty(propNameB)) return false;

      //   if (a instanceof Object) {
      //     if (this.equalsObj(a[propNameA], b[propNameA])) {
      //     } else {
      //       return false;
      //     }
      //   } else {
      //     if (a[propNameA] === b[propNameA]) {
      //     } else {
      //       return false;
      //     }
      //   }

      //   return true;
      // }
    },
    handleSelectMethod(item) {
      this.specificationInfo.MethodName = item;
      const findItem = this.handleFindPreSpecificGoods(
        this.specificationInfo.SpecificId
      );
      this.specificationInfo = Object.assign({}, this.specificationInfo, {
        MethodName: item,
        num: findItem ? findItem.num : 0,
      });
    },
    handleSelectTaste(item) {
      let tasteItem = this.specificationInfo.TasteNameObj[item];
      if (!tasteItem) {
        //选中
        this.$set(this.specificationInfo.TasteNameObj, item, item);
        // this.specificationInfo.TasteNameObj[item] = item;
      } else {
        delete this.specificationInfo.TasteNameObj[item];
      }
      const findItem = this.handleFindPreSpecificGoods(
        this.specificationInfo.SpecificId
      );
      this.specificationInfo = Object.assign({}, this.specificationInfo, {
        num: findItem ? findItem.num : 0,
      });
    },
    handleShowSelectSetmeal(item, flag) {
      this.nowPackageInfo = item;
      this.mealDialogType = flag;
      this.showSelectSetmealModal = true;
      getSetmealFoodInfo({
        goodsId: item.Id,
        vpnId: this.vpnInfo.id,
      }).then((res) => {
        res.Groups.forEach((gItem) => {
          gItem.Items.forEach((IItem, index) => {
            if (flag == "edit") {
              let preSelectObj = item.selectGoodsObj;
              console.log(preSelectObj);
              let preObjItem = preSelectObj && preSelectObj[gItem.Id];
              const findItem =
                preObjItem &&
                preObjItem.find((pItem) => pItem.GoodsId == IItem.GoodsId);
              console.log(findItem);
              IItem.num = findItem ? findItem.num : 0;
              // index + 1 <= gItem.SelectRows ? 1 : 0;
            } else {
              IItem.num = index + 1 <= gItem.SelectRows ? 1 : 0;
            }
          });
        });
        console.log(res);

        this.setMealInfo = res;
      });

    },
   
    handleSubmitSetmeal(type) {
      console.log("提交套餐");

      if (type == "add") {
        this.setMealInfo.num =0
        const stepNum = this.setMealInfo.num ? 1 : this.setMealInfo.MinBuyCount ? this.setMealInfo.MinBuyCount : 1;
        this.handlePlusNum(this.setMealInfo, stepNum||1);
        this.showSelectSetmealModal = false;
        this.mealDialogType = null;
      }
    },
    settlement() {
      // 验证该场景是否需要强制注册微会员
      verifyNeedWechatMember(2, () => {
        if (this.deskCode) {
          //已经扫过餐台码
          this.$router.push({ name: "NewPlaceOrder" });
        } else {
          this.showScanTipModal = true;
        }
      });
    },
    handleSubmitScanCode() {
      // this.$router.push(
      //   "/scanCode/takeNumberResult?action=takeorder&vc=QHCFZD&p=QHCFZD,abc,1013,20000001,8001,01,0FB9"
      // );
      this.showScanTipModal = false;
      // 调起微信扫码，扫描餐台码并跳转到选择人数页面或提交点单面
      handleScanCode({ needResult: 1 }, (res) => {
        const queryStr = res.resultStr.split("#");
        if (queryStr[1]) {
          this.$router.push(queryStr[1]);
        }
      });
    },
    // 点击购物车
    joinedCarMask() {
      if (Object.keys(this.carGoodsList).length > 0) {
        this.maskType = true;
      }
    },
    clearShoppingCar() {
      Dialog.confirm({
        title: "清空购物车",
        message: "确定清空购物车吗？",
      })
        .then(() => {
          this.handleClearCartGoods();
          if (this.isGroupConfig && this.isSureVpn) {
            handleSendMessage("SendGoodsClear", {
              TeamId: this.teamId,
              duration: this.vpnInfo.OrderTeamDuration,
            });
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    handleClearCartGoods() {
      this.handleClearCataNum();
      this.handleClearGoodsNum();
      this.maskType = false;
      this.CLEAR_LIST();
    },
    handleClearCataNum() {
      for (var i = 0; i < this.catalogList.length; i++) {
        this.catalogList[i].num = 0;
      }
    },
    handleClearGoodsNum() {
      for (let i = 0; i < this.goodsList.length; i++) {
        for (var j = 0; j < this.goodsList[i].length; j++) {
          const nowItem = this.goodsList[i][j];
          nowItem.num = 0;
          if (nowItem.IsMultiSpecific) {
            nowItem.Specifications.forEach((specItem) => (specItem.num = 0));
          }
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.notice_con {
  display: flex;
  background: #fff9e3;
  padding: 0 32px;
  .notice_icon_con {
    align-self: center;
    width: 32px;
    height: 32px;
    margin-right: 12px;
  }
  .scroll-container {
    flex: 1;
    overflow: hidden;
  }
  .c-item {
    box-sizing: border-box;
    color: #333;
  }
  .c-content {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 26px;
  }
}

.micropoint {
  line-height: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  .pageTop {
    margin-bottom: 15px;
    height: 200px;
    padding: 24px 32px 0;
    img {
      width: 100%;
      height: 200px;
      border-radius: 16px;
    }
  }
  .recommendGoodsListWrap {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 32px;
    > h3 {
      position: relative;
      line-height: 44px;
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 20px;
      margin-top: 0;
      color: #333;
    }
    .recommend_goods_con {
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      overflow-x: scroll;
      -webkit-overflow-scrolling: touch;
      &::-webkit-scrollbar {
        display: none;
      }
      display: flex;
      li {
        width: 280px;
        flex-shrink: 0;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
        border-radius: 12px;
        margin-right: 20px;
        .goods-image {
          height: 160px;
          img {
            border-radius: 12px 12px 0 0;
          }
        }
        .goods_info_con {
          padding: 20px;
          .goods_name {
            margin-bottom: 10px;
          }
          .money-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .main-money {
              span {
                color: #ff5c10;
              }
            }
          }
        }
      }
    }
  }
  .searchWrap {
    width: 100%;
    padding-left: 20px;
    box-sizing: border-box;
    display: flex;
    .van-search {
      flex: 1;
    }
    .storeLeft {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #333;
    }
    .point_search {
      .van-search__content {
        border: 1px solid #333;
        background: #fff !important;
      }
    }
  }
  .micropointContainer {
    position: relative;
    width: 100%;
    flex: 1;
    overflow: hidden;
    .hierarchy {
      position: absolute;
      top: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
    }
    .micropointSideNavbar {
      position: absolute;
      top: 0;
      left: 0;
      width: 164px;
      height: 100%;
      background: #f5f5f5;
      box-sizing: border-box;
      .sideNavbar {
        padding-bottom: 96px;
        .van-badge {
          position: absolute;
          right: 5px;
          top: 5px;
        }
      }

      p {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 104px;
        text-align: center;
        box-sizing: border-box;

        a {
          display: flex;
          display: -webkit-flex;
          align-content: center;
          justify-content: center;
          flex-flow: column wrap;
          width: 100%;
          height: 100%;
          font-size: 26px;
          line-height: 36px;
          color: #333;
        }
      }
      .active {
        &::before {
          content: "";
          width: 6px;
          height: 30px;
          background: #333;
          border-radius: 3px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        > a {
          // color: #333 !important;
          font-weight: bold;
          background: #fff;
        }
      }
    }
    .micropointGoodsList {
      position: absolute;
      top: 0;
      right: 0;
      width: 586px;
      height: 100%;
      .goodsList {
        padding-bottom: 96px;
        box-sizing: border-box;
      }

      .bigList {
        width: 100%;
        .goods_title_box {
          box-sizing: border-box;
          padding: 10px 24px;
          font-weight: 400;
          display: flex;
          justify-content: center;
        }
        .goods_title_con {
          position: relative;

          > p:first-child {
            font-size: 24px;
            color: rgba(51, 51, 51, 1);
            line-height: 34px;
            // width: 150px;
            &::before {
              content: " ";
              position: absolute;
              width: 4px;
              height: 4px;
              top: 13px;
              left: -30px;
              border-radius: 50%;
              background-color: #333;
            }
            &::after {
              content: "";
              position: absolute;
              width: 4px;
              height: 4px;
              top: 13px;
              right: -30px;
              border-radius: 50%;
              background-color: #333;
            }
          }
          // span {
          //   width: 3px;
          //   height: 3px;
          //   border-radius: 50%;
          //   background-color: #333;
          // }
          &::before {
            content: " ";
            position: absolute;
            width: 51px;
            height: 1px;
            top: 13px;
            left: -90px;
            border-radius: 50%;
            background-color: #333;
          }
          &::after {
            content: "";
            position: absolute;
            width: 51px;
            height: 1px;
            top: 13px;
            right: -90px;
            border-radius: 50%;
            background-color: #333;
          }
        }

        > li {
          position: relative;
          display: -webkit-flex;
          display: flex;
          display: -webkit-flex;
          width: 100%;
          box-sizing: border-box;
          padding: 16px 24px;
          &.recommend_goods_item {
            flex-direction: column;
            .goodsImg {
              width: 100%;
              margin-bottom: 15px;
              height: 160px;
            }
          }
          .goodsImg {
            flex: none;
            z-index: 2;
            width: 136px;
            height: 136px;
            border-radius: 16px;
            overflow: hidden;
            position: relative;
          }
          .recommend_con {
            position: absolute;
            top: 8px;
            font-size: 22px;

            background: #ff6010;
            color: #fff;
            border-radius: 0 4px 4px 0;
            padding: 5px 6px;
          }
          > .goodsDetails {
            position: relative;
            flex: 1;
            -webkit-flex: 1;
            box-sizing: border-box;
            padding-left: 15px;
            .goodsName {
              margin-bottom: 8px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 28px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 42px;
            }
            .saleNum {
              margin-bottom: 18px;
              font-size: 24px;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 30px;
            }
            .label_list_con {
              display: flex;
              flex-wrap: wrap;
              li {
                padding: 5px 6px;
                color: #ff6010;
                background: #ffece3;
                border-radius: 4px;
                font-size: 22px;
                margin-right: 8px;
              }
            }
            .sale_time_area {
              font-size: 24px;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              margin-bottom: 10px;
            }
            .price {
              line-height: 28px;
              font-size: 32px;
              font-weight: 600;
              font-family: "Roboto-Bold";

              > i {
                font-style: normal;
                font-size: 24px;
              }
            }
            .cross-price {
              text-decoration: line-through;
              color: #cccccc;
              font-size: 24px;
              margin-left: 10px;
            }
            .lastLine {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              height: 60px;
              box-sizing: border-box;
            }
            .sellOut,
            .disableSaleRemark {
              width: 100%;
              text-overflow: ellipsis;
              overflow-x: hidden;
              white-space: nowrap;
              line-height: 44px;
              font-size: 28px;
              text-align: right;
              color: #fbab55;
            }
          }
        }

        li:not(:last-child) {
          border-bottom: 2px solid #f7f7f7;
        }
      }
    }
  }
  .shoppingMask,
  .joinShoppingCartListNew {
    z-index: 3;
  }
}
.changeNumBar {
  position: relative;
  .van-badge {
    position: absolute;
    right: -8px;
    top: -8px;
  }
  .select-spec-btn {
    min-width: 110px;
    height: 48px;
    padding: 0 16px;
    font-size: 22px;
  }
}
.number_sall_out {
  color: #999;
}
.micropointFooter {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 3;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100px;
  background: #fff;
  box-sizing: border-box;
  padding: 0 22px;
  box-shadow: inset 0px 1px 0px 0px rgba(222, 222, 222, 0.5);

  .historyOrderEntry {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 24px;
    color: #333;
    line-height: 1;

    .historyOrderIcon {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
      box-sizing: border-box;
      width: 36px;
      height: 40px;
      padding: 8px 7px;
      border: 2px solid #333;
      border-radius: 6px;

      span {
        display: block;
        height: 2px;
        background: #333;
        border-radius: 1px;

        & + span {
          margin-top: 5px;
        }
      }
    }

    .historyOrderText {
      margin-top: 6px;
      font-size: 20px;
      color: #333;
      white-space: nowrap;
    }
  }

  .shoppingCart {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    height: 100%;
    line-height: 96px;

    .commodity {
      position: relative;

      .carImg {
        width: 44px;
        height: 40px;
      }

      > a {
        position: absolute;
        top: 60px;
        left: 0;
        width: 80px;
        font-size: 20px;
        color: #000000;
        line-height: 28px;
      }

      .van-badge {
        position: absolute;
        right: -10px;
        top: 0;
      }
    }

    .choose {
      color: #000000;
      font-size: 22px;

      .empty {
        font-size: 30px;
        color: #999;
        margin-right: 20px;
      }

      .price {
        font-size: 34px;
        margin-right: 20px;
      }
    }
  }
}
.shop_cart_con {
  .cartTitle {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    width: 100%;
    height: 90px;
    font-size: 28px;
    color: #333;
    font-weight: bold;

    .clear {
      height: 100%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      color: #999;
      font-size: 24px;
      font-weight: normal;

      .van-icon {
        margin-right: 5px;
      }
    }
  }

  .cart_goods_con {
    width: 100%;
    max-height: 50vh;
    overflow-y: scroll;
    box-sizing: border-box;
    padding: 14px 0px;
  }
  .cart_footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 22px;
    height: 110px;
    box-shadow: inset 0px 1px 0px 0px rgba(222, 222, 222, 0.5);
    font-size: 24px;
    .count_con {
      color: #333;
      span {
        font-size: 36px;
        font-weight: bold;
        vertical-align: middle;
      }
    }
  }
  .vpn_list_ul {
    margin: 24px;
    li {
      padding: 20px 30px;
      border-radius: 16px;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      .radio_icon {
        width: 26px;
        margin-right: 35px;
        flex-shrink: 0;
      }
      .vpn_right_con {
        flex: 1;
        display: flex;
        align-items: center;
        img {
          width: 112px;
          height: 112px;
          border-radius: 10px;
          margin-right: 24px;
          flex-shrink: 0;
        }
        p {
          color: #333;
          margin-bottom: 15px;
          font-size: 20px;
          &.name_con {
            font-size: 28px;
            font-weight: bold;
          }
          &.time_con {
            color: #999;
          }
        }
      }
    }
  }
}
.overlay_con {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.remark_overlay_con {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 48px;
  box-sizing: border-box;
}

.goods_remark_modal {
  width: 100%;
  background: #fff;
  border-radius: 24px;
  padding: 36px 32px 32px;
  box-sizing: border-box;

  .remark_modal_title {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    margin-bottom: 28px;
  }

  .remark_tag_list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 24px;
  }

  .remark_tag {
    margin: 0 16px 16px 0;
    padding: 14px 28px;
    font-size: 26px;
    color: #333;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    line-height: 1;
    &.active {
      color: #00c2c2;
      border-color: #00c2c2;
      background: rgba(0, 194, 194, 0.08);
    }
  }

  .remark_textarea {
    display: block;
    width: 100%;
    min-height: 160px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 26px;
    color: #333;
    line-height: 1.5;
    resize: none;
    outline: none;
    margin-bottom: 28px;
    &::placeholder {
      color: #c8c8c8;
    }
  }

  .remark_confirm_btn {
    height: 80px;
    font-size: 30px;
  }
}

.remark_close_btn {
  margin-top: 36px;
}

.select_specifications_con {
  padding: 24px;
  width: 85vw;
  font-size: 24px;
  border-radius: 16px;
  background: #fff;
  position: relative;
  &.meal_tip_con {
    padding: 0;
    .meal_tip_img {
      width: 100%;
      height: 60vh;
      border-radius: 16px;
      overflow: hidden;
    }
  }
  .goo_name {
    padding: 20px 0;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #333;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    margin: 20px 0 20px;
    li {
      padding: 14px 52px;
      border: 1px solid #dcdde0;
      margin-right: 20px;
      border-radius: 4px;
      margin-bottom: 20px;
      &.active {
        border: 1px solid #ff6a20;
        background: #ffece3;
        color: #ff5c10;
      }
    }
  }
  .setmeal_dialog_con {
    max-height: 60vh;
    overflow-y: auto;
  }
  .setmeal_group_title {
    padding: 0 25px;
    margin-top: 20px;
    font-size: 26px;
  }
  .setmeal_group_con {
    display: block;
    flex-wrap: nowrap;
    padding: 0 25px;
    margin: 20px 0;
    > .van-card {
      padding: 10px 0;
      ::v-deep .van-card__thumb {
        width: 150px;
        height: 100px;
      }
      ::v-deep .van-card__content {
        min-height: 100px;
      }
      ::v-deep .van-card__thumb img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    li {
      width: 100%;
      padding: 0;
      box-sizing: border-box;
      margin: 0;
      border: 0;
      border-radius: 0;
      background: #fff;
      .van-card {
        padding: 10px 0;
      }
      .goodsName {
        margin: 15px 0;
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 26px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .lastLine {
        margin-bottom: 15px;
        box-sizing: border-box;
      }
      .changeNumBar,
      .number_sall_out {
        display: flex;
        justify-content: flex-end;
      }
    }
    .goodsImg {
      width: 100%;
      height: 136px;

      overflow: hidden;
      position: relative;
    }
  }
  .specifications_input {
    display: flex;
    justify-content: space-between;
    padding: 30px 0;
  }
}
.close_btn_con {
  position: absolute;
  bottom: -90px;
  left: 50%;
  transform: translateX(-50%);
}
.scan_tip_con {
  p {
    padding: 88px 48px 48px;
    text-align: center;
    line-height: 45px;
  }
  .close_btn {
    float: right;
    margin: 20px 20px 0;
  }
}
.full_img_taocan{
  width: 100%;
  height: 236px;
}
.GoodsChangeItems{
  width: 100%;
  height: 76px;
  color: #006400;
}
.goods_change_card {
  border: 1px solid transparent;
  border-radius: 8px;
  &.active {
    border-color: #cca567;
    background: #fff8ec;
  }
}
.goods_change_selected {
  display: flex;
  align-items: center;
  color: #cca567;
  font-size: 24px;
  .van-icon {
    margin-right: 6px;
  }
}
</style>
